module.exports = __webpack_public_path__ + "static/media/Cap-Home3.a615cd5c.png";